// @react-compiler enable
import {SingleSelectToken} from '@github-ui/shared-single-select-components/SingleSelectToken'
import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'

import type {MemexColumnDataType} from '../../../api/columns/contracts/memex-column'
import type {SingleSelectValue} from '../../../api/columns/contracts/single-select'
import type {ColumnModelForDataType} from '../../../models/column-model'
import {type ColumnValue, hasValue, isLoading} from '../../../models/column-value'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {PillPlaceholder} from '../../common/placeholders'
import {BaseCell} from '../cells/base-cell'
import {DropdownCell} from '../cells/dropdown-cell'
import {useRecordCellRenderer} from '../performance-measurements'
import styles from './single-select-renderer.module.css'

type Props = Readonly<{
  currentValue: ColumnValue<SingleSelectValue>
  model: MemexItemModel
  options: ColumnModelForDataType<typeof MemexColumnDataType.SingleSelect>['settings']['options']
  dropdownRef?: React.MutableRefObject<HTMLButtonElement | null>
  isDisabled?: boolean
}>

export const LoadingSingleSelectCell = () => (
  <BaseCell>
    <PillPlaceholder minWidth={40} maxWidth={80} {...testIdProps('placeholder')} />
  </BaseCell>
)

export const SingleSelectRenderer = memo(function SingleSelectRenderer({
  currentValue,
  model,
  dropdownRef,
  options,
  isDisabled,
}: Props) {
  useRecordCellRenderer('SingleSelectRenderer', model.id)

  const valueId = hasValue(currentValue) ? currentValue.value.id : null
  const matchingOption = options.find(o => o.id === valueId)

  if (isLoading(currentValue)) {
    return <LoadingSingleSelectCell />
  }

  if (matchingOption) {
    return (
      <DropdownCell ref={dropdownRef} isDisabled={isDisabled} className={styles.DropdownCell}>
        <div className={styles.DropdownCell}>
          <SingleSelectToken option={matchingOption} />
        </div>
      </DropdownCell>
    )
  }

  return <DropdownCell ref={dropdownRef} isDisabled={isDisabled} />
})
